 
<div class="profile-container">
    <div class="">
        <div class="profile-content">

            <div class="personal-details">

           


              <div class="header-block">
                <div class="header-title">
                  <app-breadcrumb></app-breadcrumb>
                </div>
                <div class="add-block">
                  <div class="search">
                    <form autocomplete="off" >
                      <input type="text" placeholder="search" (keyup.enter)="getLatestProductStockInfoByProductName()" [ngModelOptions]="{standalone: true}" [(ngModel)]="searchKey">
                    </form>
                    <i class="bi bi-search" (click)="getLatestProductStockInfoByProductName()"></i>
                  </div>
  
                  <div class="filter-icon">
                    <i class="bi bi-arrow-clockwise" title="Refresh" (click)="refreshAll()"></i>
                  </div>
 
                </div>
              </div>
            
              <table class="table table-striped">
                  <thead>
                      <tr>
                        <th style="width: 20%;">{{ 'product-stock-info.lastTxnDate' | translate }}</th>
                        <th style="width: 30%;">{{ 'product-stock-info.productName' | translate }}</th>
                        <th style="width: 35%;">{{ 'product-stock-info.branchName' | translate }}</th>
                        <th style="width: 15%;">{{ 'product-stock-info.balanceQty' | translate }}</th>
                      </tr>
                  </thead>
              </table>
              <div *ngIf="!isLoading">
                  <div class="data-view" *ngFor="let x of stocks | paginate : {
                      itemsPerPage: tableSize,
                      currentPage: pageNumber,
                      totalItems: totalRecords
                      }  ;let i = index">
      
                      <p style="width: 20%;">{{x.createdDate | date}}</p>
                      <p style="width: 30%;" title="{{x.productName}}">{{x.productName}}</p>
                      <p style="width: 35%;" title="{{x.branchName}}">{{x.branchName}}</p>
                      <p style="width: 15%;" title="{{x.balanceQty | number: '1.2-2'}}">{{x.balanceQty | number: '1.2-2'}}</p>             
                  </div>
              </div>
      
      
              <div class="loader" *ngIf="isLoading">
                  <div class="spinner"></div>
              </div>
      
              <div class="loader"  *ngIf="!isLoading && stocks.length == 0">
                  <div class="no-data">
                      <img src="assets/no-data-6.png" alt="">
                      <p>no data found</p>
                  </div>
                  
              </div>
      
              <div class="paginator">
                  <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize" [totalRecords]="totalRecords"
                      [showFirstLastIcon]="false" [showCurrentPageReport]="true" currentPageReportTemplate="{first} - {last} of {totalRecords}"></p-paginator>
              </div>
      
        
          </div>
        </div>
    </div>
  </div>

